import { ChevronUpSmall as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronUpSmall.js';
import { UIIcon } from '@adobe/react-spectrum/private/icon/UIIcon';
import React from 'react';
export default function ChevronUpSmall(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}